module.exports = __webpack_public_path__ + "img/GoodTime2.934262cd.svg";